import React, { useState } from "react";
import { TextField, Typography, Container, Grid, Box, Avatar } from "@mui/material";
import Button from '@mui/material/Button';
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Formik } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';

import useRequestAuth from "../../hooks/useRequestAuth";

const validationSchema = yup.object({
    email: yup
        .string()
        .email("Please provide a valid email")
        .required("Email is required"),
});

export default function ForgetPassword() {

    const { requestResetPassword, loading } = useRequestAuth();
    const navigate = useNavigate();
    const [message, setMessage] = useState(null);

    const success = async () => {
        navigate("/email-sent")
    };

    const handleSubmit = (values) => {
        requestResetPassword(values.email, success, (text) => {setMessage(text)});
    };

        
    const renderError = (message) => 
    {
        return (
            <Alert variant="outlined" severity="error">
                {message}
            </Alert>            
        )
    }


    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    marginTop: (theme) => theme.spacing(8),
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Avatar
                    sx={{
                        margin: (theme) => theme.spacing(1),
                        backgroundColor: (theme) => theme.palette.secondary.main,
                    }}
                >
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" gutterBottom>
                    Reset Password
                </Typography>
                <Formik
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    validateOnBlur={false}
                    initialValues={{
                        email: "",
                    }}
                >
                    {(formik) => {
                        return (
                            <form
                                style={{
                                    width: "100%", // Fix IE 11 issue.
                                }}
                                onSubmit={formik.handleSubmit}
                            >
                               
                                <Typography variant="subtitle1" gutterBottom component="div">
                                    Enter your email address below and we will send you a password
                                    reset link
                                </Typography>

                                {message ? renderError(message) : <div></div>}

                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    required
                                    id="email"
                                    label="Email"
                                    autoFocus
                                    {...formik.getFieldProps("email")}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />

                                <Button
                                    loading={loading}
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                    color="primary"
                                    sx={{
                                        margin: (theme) => theme.spacing(3, 0, 2),
                                    }}
                                >
                                    Send Password Reset Email
                                </Button>
                            </form>
                        );
                    }}
                </Formik>
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <Link to={"/login/token"} key={"login"}>
                            {"Go back to sign in page"}
                        </Link>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}